import type { Service } from '../lib/api';
import Timeline from './Timeline';

const STATE_LABEL: Record<Service['state'], string> = {
  up: 'Operational',
  degraded: 'Degraded',
  down: 'Down',
  unknown: 'Pending',
};
const STATE_DOT: Record<Service['state'], string> = {
  up: 'bg-green',
  degraded: 'bg-yellow',
  down: 'bg-red',
  unknown: 'bg-muted',
};
const STATE_TEXT: Record<Service['state'], string> = {
  up: 'text-green',
  degraded: 'text-yellow',
  down: 'text-red',
  unknown: 'text-muted',
};

export default function ServiceRow({ service }: { service: Service }) {
  const ms = service.last_response_ms;
  return (
    <div className="card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-3">
            <span className={`inline-block w-2.5 h-2.5 rounded-full ${STATE_DOT[service.state]} ${service.state === 'down' ? 'animate-pulse' : ''}`} />
            <p className="display text-lg text-offwhite truncate tracking-wide">{service.name}</p>
          </div>
          <p className="text-xs text-offwhite/55 mt-1.5">
            {service.kind.toUpperCase()} probe
            {ms != null ? <span className="text-offwhite/40"> · </span> : null}
            {ms != null ? `${ms} ms` : null}
            <span className="text-offwhite/40"> · </span>
            24h uptime <span className="text-offwhite/80">{service.uptime_24h.toFixed(2)}%</span>
          </p>
        </div>
        <div className="text-right">
          <p className={`text-sm font-semibold ${STATE_TEXT[service.state]}`}>{STATE_LABEL[service.state]}</p>
          <p className="text-xs text-offwhite/55">30d {service.uptime_30d.toFixed(2)}%</p>
        </div>
      </div>
      <div className="mt-4">
        <Timeline serviceId={service.id} />
        <div className="flex items-center justify-between mt-2 text-[10px] uppercase tracking-wider text-offwhite/35">
          <span>90 days ago</span>
          <span>Today</span>
        </div>
      </div>
    </div>
  );
}
